import React from 'react';
import {
  Plus,
  Trash2,
  Box,
  BarChart3,
  ChevronRight,
  ChevronUp,
  ChevronDown,
  GripVertical,
} from 'lucide-react';
import { calculateUsedUnits } from './qconfigurator.types';

const QConfiguratorSidebar = ({
  modules,
  selectedModuleId,
  viewMode,
  onSelectModule,
  onAddModule,
  onDeleteModule,
  onViewSummary,
  onReorderModule,
  cabinetName,
}) => {
  return (
    <aside className="qconfig-sidebar">
      {/* Cabinet Name Header */}
      {cabinetName && (
        <div className="qconfig-sidebar-cabinet-header">
          <Box className="w-4 h-4" />
          <span>{cabinetName}</span>
        </div>
      )}

      {/* Add Module Button */}
      <button onClick={onAddModule} className="qconfig-add-module-btn">
        <Plus className="w-5 h-5" />
        <span>Add Module</span>
      </button>

      {/* Modules List */}
      <div className="qconfig-modules-list">
        <div className="qconfig-sidebar-section-title">
          <Box className="w-4 h-4" />
          <span>Modules ({modules.length})</span>
        </div>

        {modules.length === 0 ? (
          <div className="qconfig-no-modules">
            <p>No modules yet</p>
            <p className="text-sm">Click "Add Module" to create your first tool cabinet module</p>
          </div>
        ) : (
          <ul className="qconfig-module-items">
            {modules.map((module, index) => {
              const drawers = module.drawers || [];
              const usedUnits = calculateUsedUnits(drawers);
              const isSelected = selectedModuleId === module.id && viewMode === 'editor';
              const isFirst = index === 0;
              const isLast = index === modules.length - 1;

              return (
                <li
                  key={module.id}
                  className={`qconfig-module-item ${isSelected ? 'selected' : ''}`}
                >
                  {/* Reorder buttons */}
                  <div className="qconfig-module-reorder">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isFirst && onReorderModule) onReorderModule(index, index - 1);
                      }}
                      className="qconfig-reorder-btn"
                      disabled={isFirst}
                      title="Move up"
                    >
                      <ChevronUp className="w-3 h-3" />
                    </button>
                    <span className="qconfig-module-position">{index + 1}</span>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!isLast && onReorderModule) onReorderModule(index, index + 1);
                      }}
                      className="qconfig-reorder-btn"
                      disabled={isLast}
                      title="Move down"
                    >
                      <ChevronDown className="w-3 h-3" />
                    </button>
                  </div>
                  <button
                    onClick={() => onSelectModule(module.id)}
                    className="qconfig-module-item-content"
                  >
                    <div
                      className="qconfig-module-color-indicator"
                      style={{ backgroundColor: module.color }}
                    />
                    <div className="qconfig-module-info">
                      <span className="qconfig-module-name">{module.name}</span>
                      <span className="qconfig-module-meta">
                        {drawers.length} drawer{drawers.length !== 1 ? 's' : ''} &bull; {usedUnits}/3 units
                      </span>
                    </div>
                    <ChevronRight className={`qconfig-module-chevron ${isSelected ? 'active' : ''}`} />
                  </button>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      if (window.confirm(`Delete "${module.name}"? This action cannot be undone.`)) {
                        onDeleteModule(module.id);
                      }
                    }}
                    className="qconfig-module-delete-btn"
                    title="Delete module"
                  >
                    <Trash2 className="w-4 h-4" />
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>

      {/* Summary Button */}
      <div className="qconfig-sidebar-footer">
        <button
          onClick={onViewSummary}
          className={`qconfig-summary-btn ${viewMode === 'summary' ? 'active' : ''}`}
        >
          <BarChart3 className="w-5 h-5" />
          <span>View Summary Report</span>
        </button>
      </div>
    </aside>
  );
};

export default QConfiguratorSidebar;
